import React from 'react';
import type { Portfolio } from 'venn-api';
import { useAllocationSearch } from './AllocationSearchContext';
import { AddInvestmentCommonHeader } from '../../modals/add-investment-common-modal';
import { ModalContent } from '../../modal';

interface AllocationSearchConstituentViewRedesignedProps {
  onClose: () => void;
  constituents: Portfolio[];
}

export const AllocationSearchConstituentViewRedesigned: React.FC<AllocationSearchConstituentViewRedesignedProps> = ({
  onClose,
  constituents,
}) => {
  const { handleConstituentSelect } = useAllocationSearch();
  const title = <strong>Add investment to...</strong>;

  return (
    <>
      <AddInvestmentCommonHeader title={title} onClose={onClose} />
      <ModalContent className="p-0 flex-1 min-h-0 overflow-hidden">
        <div className="flex-1 flex flex-col overflow-hidden">
          <div className="overflow-y-auto max-h-[380px]">
            <ul className="list-none m-0 p-0 border-0 border-solid border-venn-grey-30">
              {constituents.map((constituent) => (
                <li key={constituent.id}>
                  <button
                    type="button"
                    onClick={() => handleConstituentSelect(constituent)}
                    className="qa-constituent-option w-full text-left border border-x-0 border-t-0 border-solid border-venn-grey-30 px-[16px] py-[8px] text-venn-black hover:bg-venn-grey-10 hover:text-venn-black text-[14px]"
                  >
                    {constituent.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </ModalContent>
    </>
  );
};
